"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _core = require("@material-ui/core");
var _styles = require("@material-ui/core/styles");
var __jsx = _react.default.createElement;
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    detail: (0, _defineProperty2.default)({
      display: 'flex',
      flexDirection: 'column',
      marginTop: theme.spacing(2.5)
    }, theme.breakpoints.up('md'), {
      flexDirection: 'row',
      marginTop: theme.spacing(0),
      marginBottom: theme.spacing(0.75)
    }),
    detailLabel: {
      fontWeight: theme.typography.fontWeightMedium,
      marginTop: theme.spacing(0),
      minWidth: '86px'
    },
    detailValues: {
      display: 'flex',
      flexDirection: 'column'
    }
  };
});
var wrapStringsWithSpansReducer = function wrapStringsWithSpansReducer(accumulator, currentValue) {
  return accumulator + "<span>".concat(currentValue, "</span>");
};
var getDetailValueMarkup = function getDetailValueMarkup(valueArray) {
  return valueArray.reduce(wrapStringsWithSpansReducer);
};
var ListItem = function ListItem(_ref) {
  var detailLabel = _ref.detailLabel,
    _ref$detailValues = _ref.detailValues,
    detailValues = _ref$detailValues === void 0 ? [] : _ref$detailValues;
  var classes = useStyles();
  return __jsx("div", {
    className: classes.detail
  }, __jsx(_core.Typography, {
    component: "dt",
    className: classes.detailLabel,
    dangerouslySetInnerHTML: {
      __html: "".concat(detailLabel, ":")
    }
  }), __jsx(_core.Typography, {
    component: "dd",
    className: classes.detailValues,
    dangerouslySetInnerHTML: {
      __html: getDetailValueMarkup(detailValues)
    }
  }));
};
var _default = ListItem;
exports.default = _default;